import McmJob from '~/tenants/mcm/model/McmJob';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { TenantJobLine } from '~/lib/model';
import { Big } from 'big.js';
import McmSlideshowConfig, { McmSlideshowOrientation } from '~/tenants/mcm/performable/slideshow/McmSlideshowConfig';
import { DeliverableType } from '~common/model/Deliverable';

export default class McmSlideshowJob extends McmJob<typeof McmSlideshowConfig> {
  get performable() {
    return McmSlideshowConfig;
  }

  get configurable() {
    return true;
  }

  get deliverable() {
    return DeliverableType.SLIDESHOW;
  }

  defaultValue(): ZodVersionedMetadata<(typeof McmSlideshowConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP,
      orientation: McmSlideshowOrientation.HORIZONTAL,
    };
  }

  revenueLines(): TenantJobLine[] {
    const lines: TenantJobLine[] = [];

    let type = 'Horizontal + Vertical';
    let amount = new Big('69.95');

    if (this.metadata.orientation === McmSlideshowOrientation.HORIZONTAL) {
      type = 'Horizontal';
    } else if (this.metadata.orientation === McmSlideshowOrientation.VERTICAL) {
      type = 'Vertical';
    } else {
      amount = amount.plus(new Big('50.00'));
    }

    lines.push({
      id: 'slideshow',
      description: `${type} Slideshow`,
      amount,
      taxable: true,
    });

    return lines;
  }

  get eligible(): boolean {
    return !this.buyer('crossroads');
  }

  onsite(): number {
    return 0;
  }
}
